import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Position } from '@xyflow/react';
import { Radio } from 'lucide-react';
import { FlowMetaContext } from '../FlowEditorContext';
import { HIGHLIGHT_OUTLINE } from '../editor-styles';
import { eventLabel } from '../schema';
import { MultiHandle } from './MultiHandle';
/** Closes the gaps in flow order after a flow is removed. */
export function renumberFlows(nodes) {
    const ordered = nodes
        .filter(n => n.type === 'flowStart')
        .sort((a, b) => a.data.order -
        b.data.order)
        .map(n => n.id);
    return nodes.map(n => n.type === 'flowStart'
        ? { ...n, data: { ...n.data, order: ordered.indexOf(n.id) } }
        : n);
}
/** Where a cross-cutting flow starts: the events that start it, from anywhere. */
export function FlowStartNode({ id, selected, data }) {
    const { edgeHighlightedNodeIds } = useContext(FlowMetaContext);
    const highlight = edgeHighlightedNodeIds.has(id);
    const { events } = data;
    return (_jsxs("div", { className: "flex items-center gap-1.5 rounded-full border-2 border-foreground bg-card px-3 py-1.5 shadow-sm", style: selected || highlight ? HIGHLIGHT_OUTLINE : undefined, children: [_jsx(Radio, { className: "h-3.5 w-3.5 text-primary" }), _jsx("span", { className: "text-xs font-medium", children: events.length > 0
                    ? events.map(eventLabel).join(' + ')
                    : 'Pick what starts it' }), _jsx(MultiHandle, { nodeId: id, handleType: "source", nodeSelected: !!selected, position: Position.Right, side: "right" }), _jsx(MultiHandle, { nodeId: id, handleType: "source", nodeSelected: !!selected, position: Position.Bottom, side: "bottom" })] }));
}
//# sourceMappingURL=FlowStartNode.js.map